import { FloorController } from "./floorController";

export class FloorWidget {

    floorController: FloorController;
    getHTMLId: boolean;
    isDesigner:boolean;
    planId: number;
    

    changeFloor = (event: any) => {
        this.floorController.changeFloor(event.currentTarget.paramId);
        this.updateIcon();
        this.updateSelected();
    }

    download = (event: any) => {
        this.floorController.downloadRhinovFloorFormat(event.currentTarget.paramId, event.currentTarget.planId);
    }

    importFloor = (event: any) => {
        this.floorController.importRhinovFloorFormat(event.currentTarget.paramId)
    }

    deleteFloor = (event: any) => {
        this.floorController.deleteFloor(event.currentTarget.paramId);
        this.updateList();
        event.stopPropagation();
    }

    addFloor = (event: any) => {
        this.floorController.addFloor(event.currentTarget.id === "addFloorUp");
        this.updateList();
        event.stopPropagation();
    }

    handlehover = (event: any) => {
        if (event.type === 'mouseover') {
            this.floorController.hoverFloor = event.currentTarget.param;
            if (this.isDesigner && event.currentTarget.paramIndex != 0) {
                let swapUp = document.getElementById(`swapUp-${event.currentTarget.paramIndex}`);
                if (swapUp) {
                    swapUp.style.display = "";
                }
            }
            if (this.isDesigner && event.currentTarget.paramIndex < this.floorController.floors.length - 1) {
                let swapDown = document.getElementById(`swapDown-${event.currentTarget.paramIndex}`);
                if (swapDown) {
                    swapDown.style.display = "";
                }
            }

            return;
        }
        let swapDown = document.getElementById(`swapDown-${event.currentTarget.paramIndex}`);
        if (swapDown) {
            swapDown.style.display = 'none';
        }
        let swapUp = document.getElementById(`swapUp-${event.currentTarget.paramIndex}`);
        if (swapUp) {
            swapUp.style.display = 'none';
        }
        this.floorController.hoverFloor = null;
    }

    swap = (event: any) => {
        this.floorController.swapFloor(event.currentTarget.param, this.floorController.floors[event.currentTarget.paramIndex]);
        this.updateList();
        this.updateSelected();
        event.stopPropagation();
    }

    eventFloor = [
        {id: "addFloorUp", event: 'click', handler: this.addFloor},
        {id: "addFloorDown", event: 'click', handler: this.addFloor},
    ];


    constructor (getHTMLId: boolean, isDesigner: boolean, planId: number) {
        this.getHTMLId = getHTMLId;
        this.isDesigner = isDesigner;
        this.planId = planId;
        this.floorController = new FloorController();
    }

    setFloorListener() {
        if (this.getHTMLId) {
            this.floorController.floors.forEach((floor: any, index: any) => {
                let element = document.getElementById(`floor-${index}`) as HTMLInputElement & { paramId?: number, paramName?: string };
                if (!element) return;
                element.paramId = floor.id;
                element.paramName = floor.name;
                element.addEventListener('click', this.changeFloor);
            })
            return;
        }
        this.eventFloor.forEach(({id, event, handler}) => {
            let element = document.getElementById(id);
            if (!element) return;
            element.addEventListener(event, handler);
        });
        this.setFloorListListener()
    }

    removeFloorListener() {
        if (this.getHTMLId) {
            this.floorController.floors.forEach((_floor: any, index: any) => {
                let element = document.getElementById(`floor-${index}`);
                if (!element) return;
                element.removeEventListener('click', this.changeFloor);
            })
            return;
        }
        this.eventFloor.forEach(({id, event, handler}) => {
            let element = document.getElementById(id);
            if (!element) return;
            element.removeEventListener(event, handler);
        });
        this.removeFloorListListener()
    }

    updateList() {
        let floor = document.getElementById('floorList');
        if (!floor) return;
        this.removeFloorListListener();
        floor.innerHTML = this.ManagefloorsButtons();
        this.updateIcon();
        this.setFloorListListener();
    }

    updateSelected() {
        this.floorController.floors.forEach((floor: any, index: any) => {
            let button = document.getElementById(`floor-${index}`);
            if (!button) return;
            if (floor.floorName === this.floorController.currentFloorName){
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
            if (this.getHTMLId) return;
            let dot = document.getElementById(`selectedFloor-${index}`);
            if (!dot) return;
            if (floor.floorName === this.floorController.currentFloorName){
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
    }

    removeFloorListListener(){
        this.floorController.floors.forEach((_floor: any, index: any) => {
            let container = document.getElementById(`buttonsContainer-${index}`);
            if (container) {
                container.removeEventListener('mouseover', this.handlehover);
                container.removeEventListener('mouseleave', this.handlehover)
            }
            let actualFloor = document.getElementById(`floor-${index}`);
            if (actualFloor) {
                actualFloor.removeEventListener('click', this.changeFloor);
            }
            let deleteFloor = document.getElementById(`deleteFloor-${index}`);
            if (deleteFloor) {
        
                deleteFloor.removeEventListener('click', this.deleteFloor)
            }
            let download = document.getElementById(`downloadFloor-${index}`);
            if (download) {
                download.removeEventListener('click', this.download)
            }
            let importFloor = document.getElementById(`importFloor-${index}`);
            if (importFloor) {
                importFloor.removeEventListener('click', this.importFloor)
            }
            let swapDown = document.getElementById(`swapDown-${index}`);
            if (swapDown) {
                swapDown.removeEventListener('click', this.swap);
            }
            let swapUp = document.getElementById(`swapUp-${index}`);
            if (swapUp) {
                swapUp.removeEventListener('click', this.swap);
            }
        })
    }

    setFloorListListener(){
        this.floorController.floors.forEach((floor: any, index: any) => {
            let container = document.getElementById(`buttonsContainer-${index}`) as HTMLInputElement & { param?: any, paramIndex?: number };
            if (container) {
                container.param = floor;
                container.paramIndex = index;
                container.addEventListener('mouseover', this.handlehover);
                container.addEventListener('mouseleave', this.handlehover)
            }
            let actualFloor = document.getElementById(`floor-${index}`) as HTMLInputElement & { paramId?: number, paramName?: string };;
            if (actualFloor) {
                actualFloor.paramId = floor.id;
                actualFloor.paramName = floor.name;
                actualFloor.addEventListener('click', this.changeFloor);
            }
            let deleteFloor = document.getElementById(`deleteFloor-${index}`) as HTMLInputElement & { paramId?: number };
            if (deleteFloor) {
                deleteFloor.paramId = floor.id;
                deleteFloor.addEventListener('click', this.deleteFloor)
            }
            let download = document.getElementById(`downloadFloor-${index}`) as HTMLInputElement & { paramId?: number, planId?: number };;
            if (download) {
                download.paramId = floor.id;
                download.planId = this.planId;
                download.addEventListener('click', this.download)
            }
            let importFloor = document.getElementById(`importFloor-${index}`) as HTMLInputElement & { paramId?: number };
            if (importFloor) {
                importFloor.paramId = floor.id;
                importFloor.addEventListener('click', this.importFloor)
            }
            let swapDown = document.getElementById(`swapDown-${index}`) as HTMLInputElement & { param?: any, paramIndex?: number };;
            if (swapDown) {
                swapDown.param = floor;
                swapDown.paramIndex = index + 1;
                swapDown.addEventListener('click', this.swap);
            }
            let swapUp = document.getElementById(`swapUp-${index}`) as HTMLInputElement & { param?: any, paramIndex?: number };;
            if (swapUp) {
                swapUp.param = floor;
                swapUp.paramIndex = index - 1;
                swapUp.addEventListener('click', this.swap);
            }
        })
    }

    html(): string {
        if (this.getHTMLId) {

            return ` 
                <div>
                    <div class="btn-group-vertical dropdown">
                        <section id="floorButton" class="floorIcons">
                            <img class="floorIconRoof" src="${this.floorController.roofUrl + (this.floorController.floors.length > 0 ?this.floorController.floors[0].sufix : 'ON.png')}"/>
                            <div id="floorImg">
                                ${this.ManageIcon()}
                            </div>
                        </section>
                            <ul id="floorMenu" class="dropdown-menu floorDropDown-menu rhinov" role="menu"  aria-labelledby="single-button" style="display:none;">
                                ${this.Managefloors()}
                            </ul>
                            <span  style="font-size: 10px;">${this.floorController.currentFloorName}</span>
                    </div>
                </div>
                <!-- FLOOR MANAGER -->
                <div class="tool-separator"></div>
            `;
        }
        return `
            <div>
                <!-- Floor management popup box -->
                <div class="btn-group-vertical dropdown">

                    <section id="floorButton" class="floorIcons">
                        <img id="roof-image"class="floorIconRoof" src="${this.floorController.roofUrl + (this.floorController.floors.length > 0 ? this.floorController.floors[0].sufix : 'ON.png')}"/>
                        <div id="floorImg">
                            ${this.ManageIcon()}
                        </div>
                    </section>

                    <ul id="floorMenu" class="dropdown-menu floorDropDown-menu" role="menu" aria-labelledby="single-button" style="display:none;">
                        <!-- Popup title and close button -->
                        <li id="closeFloor" class="clearfix" style="padding-top:12px;margin-left:30px">Gestionnaire d'étages<a class="icon-Close pull-right"></a></li>

                        <!-- Small separator -->
                        <div class="hr-small"></div>

                        <!-- + button above floor list (Add above) -->
                        <li id="addFloorUp" title="Ajouter au dessus" style="text-align: center;"><a class="dropdown"><span class="icon-FloatBar_Plus plus-sign"></span></a></li>

                        <!-- Floor list -->
                        <ul id="floorList" class="floor-list rhinov clearfix" style="list-style-type: none;">
                            ${this.ManagefloorsButtons()}
                        </ul>

                        <!-- + button below floor list (Add below) -->
                        <li id="addFloorDown" title="Ajouter en dessous" style="text-align:center"><a class="dropdown"><span class="icon-FloatBar_Plus plus-sign"></span></a></li>

                        <!-- Small separator -->
                        <div class="hr-small"></div>

                        <!-- Floor creation options -->
                        <li>
                            <div class="col-xs-12 info-floor" style="margin-left:30px" translate>Garder lors de l'ajout :</div>
                            <div class='clearfix col-xs-12 info-floor' style="margin-left:30px">
                                <div class='checkbox-container'>
                                    <div class='checkbox checkbox-primary'>
                                        <input type='checkbox' class="form-check-input" id='exportWalls' name='exportWalls' checked/>
                                        <label for='exportWalls' style="margin : 3px auto auto 10px" translate>Murs d'enceinte et Poteaux</label>
                                        <div class='check'>
                                            <div class='inside'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class='checkbox-container'>
                                    <div class='checkbox checkbox-primary'>
                                        <input type='checkbox' id='exportJoineries' name='exportJoineries' />
                                        <label for='exportJoineries' style="margin : 3px auto auto 10px;margin-right:30px" translate>Menuiseries</label>
                                        <div class='check'>
                                            <div class='inside'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class='checkbox-container'>
                                    <div class='checkbox checkbox-primary'>
                                        <input type='checkbox' class="form-check-input" id='exportAllTheRest' name='exportAllTheRest' checked/>
                                        <label for='exportAllTheRest' style="margin : 3px auto auto 10px" translate>Tout le reste</label>
                                        <div class='check'>
                                            <div class='inside'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class='checkbox-container'>
                                    <div class='checkbox checkbox-primary'>
                                        <input type='checkbox' id='exportPaperSketch' name='exportPaperSketch' />
                                        <label for='exportPaperSketch' style="margin : 3px auto auto 10px" translate>Plan papier</label>
                                        <div class='check'>
                                            <div class='inside'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <div style="margin-bottom:10px"></div>
                    </ul>
                    <span class="floorButtonLabel"  style="font-size: 10px;">${this.floorController.currentFloorName}</span>
                </div>
            </div>
            <div class="tool-separator"></div>
        `;
    }

    

    updateIcon(){
        let element = document.getElementById('floorImg');
        if (!element) return;
        element.innerHTML = this.ManageIcon();
    }

    ManageIcon(): string {
        let html = "";
        this.floorController.floors.forEach((floor: any) => {
            html += `
                <img class="${floor.src === this.floorController.levelUpUrl ? 'floorIconUp' : ''}" src="${floor.src + floor.sufix}"/>
            `
        });
        return html;
    }

    ManagefloorsButtons(): string {
        let html = "";
        this.floorController.floors.forEach((floor: any, index: any) => {
            html += `
                <!-- Repeat for each floor in the floors array -->
                <li id="buttonsContainer-${index}" style="text-align: left; padding : 8px 15px 8px 15px">
                    <img id="selectedFloor-${index}" src="${this.floorController.dotUrl}" class="${floor.floorName === this.floorController.currentFloorName ? 'active' : ''}" style="margin-left:5px;margin-right:5px">
                    <a id="floor-${index}" class="floor-name ${floor.floorName === this.floorController.currentFloorName ? 'active' : ''}">
                        ${floor.floorName}
                        <!-- Delete floor button -->
                        ${floor.hideDelete ? "" :`<span id="deleteFloor-${index}" title="Supprimer" class="material-icons icon-Delete pull-right floor-delete" style="font-size:150%;padding-left:10px"></span>`}
                        <!-- Download floor rhinov format -->
                        <span id="downloadFloor-${index}" title="Exporter" class="material-icons icon-Import inversed pull-right floor-delete" style="font-size:150%;padding-right:10px;margin-top:0px;"></span>
                        <!-- Import floor rhinov format -->
                        <span id="importFloor-${index}" title="Importer" class="material-icons icon-Import pull-right floor-delete" style="font-size:150%"></span>
                        <!-- Swap floor up/Move up -->
                        <span id="swapUp-${index}" title="Monter" style="font-size:14px;margin-left:8px;display:none;" class="fa-solid fa-arrow-up"></span>
                        <!-- Swp floor down/Move down -->
                        <span id="swapDown-${index}" title="Descendre" style="font-size:14px;margin-left:8px;display:none;" class="fa-solid fa-arrow-down"></span>
                    </a>
                </li>
            `;
        });
        html += `<li class="separator" style="margin-right:0;margin-left:0;margin-bottom:0"></li>`;
        return html;
        
    }

    Managefloors(): string {
        let html = "";
        this.floorController.floors.forEach((floor: any, index: any) => {
            html += `
                <li id="floor-${index}" style="text-align: left" class="${floor.floorName === this.floorController.currentFloorName ? 'active' : ''}" >
                    <a>${floor.floorName}</a>
                </li>
            `
        })
        return html;
    }
}